import { ColGroupDef } from '@ag-grid-community/core';

import { getCellClassForGroups } from '@shared/utils/ag-cell-class-for-groups';
import { Utils } from '@shared/utils/utils';

import {
  currencyFormatter,
  defaultHeaderClass,
  defaultMinWidth,
  defaultWidthForMoneyColumns,
  InMonthAdjustmentGridConfigContext,
} from './ima-grid-config-context';

export const imaPreviousMonthColumnGroup = (
  _ctx: InMonthAdjustmentGridConfigContext
): ColGroupDef => {
  return {
    children: [
      {
        cellClass: (params) => ['text-right', ...getCellClassForGroups(params)],
        field: 'prev_month_unit',
        filter: 'agNumberColumnFilter',
        headerClass: defaultHeaderClass,
        headerName: 'Actuals (Units)',
        headerTooltip: 'Actuals (Units)',
        minWidth: defaultMinWidth,
        valueFormatter: (params) => Utils.decimalFormatter(params.value),
        width: 110,
      },
      {
        cellClass: (params) => ['text-right', ...getCellClassForGroups(params)],
        field: 'prev_month_amount',
        filter: 'agNumberColumnFilter',
        headerClass: defaultHeaderClass,
        headerName: 'Actuals ($)',
        headerTooltip: 'Actuals ($)',
        minWidth: defaultMinWidth,
        valueFormatter: currencyFormatter,
        width: defaultWidthForMoneyColumns,
      },
    ],
    headerClass: ['text-center', 'header-marker'],
    headerName: 'Previous Month',
    suppressStickyLabel: true,
  };
};
